<template>
  <div class="office ba-office">
    <div class="office__details ba-office__details">
      <div class="office-name">
        <h3>{{ office.name }}</h3>
        <template v-if="office">
          <div class="office-address" data-testid="office-address">
            <span class="street">{{ office.streetAddress }}</span>
            <span class="post">{{ office.postalCode }} {{ office.postOffice }}</span>
          </div>
        </template>
      </div>

      <div class="office-contact">
        <div class="office-contacts-wrapper">
          <div>
            <a v-if="office.phone" :href="`tel:${office.phone}`" class="contact telephone" tabindex="0">
              <i class="icon-phone-circled"></i>
              <span>{{ office.phone }}</span>
            </a>
            <RouterLink
              class="call-pricing-link basic-link"
              :to="`${staticPage.paths.pricing}#puheluhinnat`"
              tabindex="0"
            >
              Katso puheluhinnat
            </RouterLink>
          </div>
          <div>
            <span v-if="office.email" class="contact email">
              <i class="icon-mail-circled"></i>
              <span>{{ office.email }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="office-hours">
        <span v-if="office.availability">{{ office.availability }}</span>
      </div>

      <div class="office-actions">
        <form-button text="Ota yhteyttä" theme="primary" tabindex="0" @click="openAgencyForm()" />
      </div>
    </div>
    <dialogue :identifier="`office-agency-dialogue-${office.id}`">
      <template #dialogueContent>
        <agency-contact :office="office" />
      </template>
    </dialogue>
  </div>
</template>

<script lang="ts">
import { staticPage } from '@/app/routes';
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'Office',
  components: {
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
    AgencyContact: defineAsyncComponent(() => import('@/app/components/agency-contact/agency-contact.vue')),
    Dialogue: defineAsyncComponent(() => import('@/app/components/dialogue/dialogue.vue')),
  },
  props: {
    office: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    staticPage,
  }),
  computed: {
    personnel() {
      return this.office.agents || this.office.employee;
    },
  },
  methods: {
    openAgencyForm() {
      this.$bus.$emit('openDialogue', `office-agency-dialogue-${this.office.id}`);
    },
    picturesExist() {
      const persons: any[] = this.office.agents || this.office.employee;
      return Object.values(persons).some((x) => 'pictureUrl' in x);
    },
  },
});
</script>
